import type { FileFetchingDetails, IntegrationData, PlatformIntegrationData } from "../Integrations.types"
import {
	integrationListCVList,
	integrationGetCVContent,
	integrationGetUserDetails,
} from "shared/src/libs/apiLib/apiLib"

export const trackerClientId = "EvoApi_1.0"

const BASE_URL = "https://evoapi.tracker-rms.com"

export const getTrackerLoginUrl = (integrationData: IntegrationData, state?: string): string => {
	const stateQueryString = state ? `&state=${encodeURIComponent(state)}` : ""
	const redirectUri = encodeURIComponent(`${window.location.origin}/oauthcallback`)
	return `${BASE_URL}/oauth2/authorize?response_type=code&client_id=${trackerClientId}&redirect_uri=${redirectUri}&scope=read,write${stateQueryString}`
}

export const trackerIntegrationData: PlatformIntegrationData<
	"oauthLogin" | "setupUser" | "checkForExisting" | "chooseFile" | "fetchFile" | "confirmationPage"
> = {
	allowChat: true,
	parameterMapping: {
		clientId: "clientId",
		externalClientId: "externalClientId",
		externalId: "externalId",
		userId: "userId",
	},
	pages: ["oauthLogin", "setupUser", "checkForExisting", "chooseFile", "fetchFile", "confirmationPage"],
	props: {
		oauthLogin: {
			newTab: false,
			createStateData: ({ sig, integrationData, clientId }) => ({ sig, integrationData, clientId }),
			getLoginUrl: getTrackerLoginUrl,
		},
		setupUser: {
			getUserDetails: async (clientId: string, integrationData: IntegrationData) => {
				return await integrationGetUserDetails(integrationData, clientId)
			},
		},
		fetchFile: {
			getFile: async (clientId: string, integrationData: IntegrationData, fileFetchingDetails: FileFetchingDetails) => {
				return await integrationGetCVContent(integrationData, fileFetchingDetails, clientId)
			},
		},
		chooseFile: {
			listFiles: async (clientId: string, integrationData: IntegrationData) => {
				return await integrationListCVList(integrationData, clientId)
			},
		},
		confirmationPage: {},
		checkForExisting: {},
	},
	initialData: {},
	useFrontendFileUpload: false,
}
